// extracted by extract-css-chunks-webpack-plugin
module.exports = {"artists":"app-components-staticpages-blocks-entityblock--artists"};